import { useQuery } from '@tanstack/react-query'
import { VehicleModel } from '@/app/models'
import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
import { axiosInstance } from '@/modules/shared/lib/axios'

interface UseQueryVehiclesProps {
  companyId: string
  enabled?: boolean
}

export function useQueryVehicles({
  companyId,
  enabled = true,
}: UseQueryVehiclesProps) {
  const startLoading = useLoadingStore((s) => s.startLoading)
  return useQuery<VehicleModel[]>({
    queryKey: ['vehicles', companyId],
    queryFn: async () => {
      const stopLoading = startLoading()
      try {
        const res = await axiosInstance.get(`/api/${companyId}/vehicle/list`)
        return res.data || []
      } catch (err) {
        console.error('Error fetching vehicles:', err)
        return []
      } finally {
        stopLoading()
      }
    },
    enabled: !!companyId && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
